import styled from "styled-components";

interface SliderImageProps {
  isFullScreen?: boolean;
}

interface HeaderProps {
  backgroundColor?: string;
}

interface TitleBoxProps {
  descriptionBackground?: string;
}

interface VideoWrapperProps {
  haveSlide?: boolean;
}

export const Box = styled.div`
  width: 100%;
`;

export const Header = styled.div<HeaderProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 26px 0 ;
  height: 79px;
  background-color: ${({ backgroundColor }) => backgroundColor} ;
  width: 100%;
`;

export const HeaderImage = styled.img`
  height: 79px;
  object-fit: contain;

`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;

`

export const Content = styled.div<{backgroundImage?: string}>`
  min-height: calc(100vh - 79px);
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  height: calc(100vh - 79px);
  padding-top: 64px;
  gap: 32px;
  background-color: #f7f7fc;

  background-image: ${({backgroundImage}) => `url(${backgroundImage})`};
  background-repeat: none repeat;
  background-size: cover;
  background-position: center;

  @media screen and (max-width: 1000px) {
    flex-direction: column;
    height: auto;
    align-items: center;
    padding-bottom: 63px;
  }
`;

export const SlideWrapper = styled.div`
  max-width: 900px;
  width: 100%;

  @media screen and (max-width: 1000px) {
    max-width: 90%;
  }
`;

export const SliderImage = styled.img<SliderImageProps>`
  width: 100%;
  height: auto;
  height: ${(props) => (props.isFullScreen ? "90%" : "auto")};
  aspect-ratio: 16 / 9;
  object-fit: ${(props) => (props.isFullScreen ? "contain" : "cover")};
`;

export const SlidePanel = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  align-self: stretch;
  gap: 16px;
  padding: 8px 32px;
  background: #d6d8e7;
  border-radius: 0px 0px 8px 8px;
  margin-top: -3px;
  height: 50px;
`;

export const SlideText = styled.p`
  margin-bottom: 2px;
`;

export const TitleBox = styled.div<TitleBoxProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 32px;
  background: ${({ descriptionBackground }) => descriptionBackground};
  border-radius: 8px 8px 0px 0px;
  margin-top: -3px;
  height: 50px;
`;

export const Chat = styled.div<VideoWrapperProps>`
  border-radius: 8px;
  & iframe {
    border-radius: 8px;
  }

  ${props => !props.haveSlide && `
    display: block;
    & iframe {
      height: 565px;
    }
  `}

  @media screen and (max-width: 1800px) {
    ${props => !props.haveSlide && `
    & iframe {
      width: 400px;
    }
  `}
  }

  @media screen and (max-width: 1500px) {
    ${props => !props.haveSlide && `
    & iframe {
      width: 350px;
    }
  `}
  }

  @media screen and (max-width: 1000px) {
    width: 100%;
    display: flex;
    & iframe {
      width: 100%;
      height: 500px;
    }
  }
`;

export const VideoWrapper = styled.div<VideoWrapperProps>`
  gap: 32px;
  
  ${props => !props.haveSlide && `
    width: 100%;
    max-width: 1600px;
    display: flex;
    justify-content: center;
  `}

  @media screen and (max-width: 1000px) {
    width: 90%;
    ${props => !props.haveSlide && `
    width: 90%;
    max-width: 1600px;
    display: flex;
    justify-content: center;
    flex-direction: column;
  `}
  }
`;

export const Video = styled.div<VideoWrapperProps>`
  margin-bottom: 16px;


@media screen and (max-width: 1760px) {
    ${props => !props.haveSlide && `
    & iframe {
      width: 1000px ;
      height: 600px;
    }
  `}
}

@media screen and (max-width: 1800px) {
    ${props => !props.haveSlide && `
    & iframe {
      width: 1200px;
    }
  `}
  }

@media screen and (max-width: 1600px) {
    ${props => !props.haveSlide && `
    & iframe {
      width: 1000px !important;
    }
  `}
  }

@media screen and (max-width: 1405px) {
    ${props => !props.haveSlide && `
    & iframe {
      width: 800px !important;
    }
  `}
  }

@media screen and (max-width: 1220px) {
    ${props => !props.haveSlide && `
    & iframe {
      width: 600px !important;
      height: 400px !important;
    }
  `}
  }



  @media screen and (max-width: 1000px) {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    & iframe {
      width: 100% !important;
      /* height: 500px !important; */
    }
  }
  
    @media screen and (max-width: 670px) {
      & iframe {
        height: 300px !important;
      }

  @media screen and (max-width: 420px) {
    & iframe {
      height: 200px !important;
    }
  }
  }

  ${props => !props.haveSlide && `
    width: 100%;
    & iframe {
    width: 1100px;
    height: 600px;
  }
  `}
`;

export const Slider = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
`;

export const Title = styled.p`
  color: white;
  text-align: center;
  margin:0;
  font-size: 20px;
`;
